var map = {
	"./date-iso.d": "./app/frontend/src/javascript/typings/date-iso.d.ts",
	"./date-iso.d.ts": "./app/frontend/src/javascript/typings/date-iso.d.ts",
	"./import-png.d": "./app/frontend/src/javascript/typings/import-png.d.ts",
	"./import-png.d.ts": "./app/frontend/src/javascript/typings/import-png.d.ts",
	"./import-svg.d": "./app/frontend/src/javascript/typings/import-svg.d.ts",
	"./import-svg.d.ts": "./app/frontend/src/javascript/typings/import-svg.d.ts",
	"src/javascript/typings/date-iso.d": "./app/frontend/src/javascript/typings/date-iso.d.ts",
	"src/javascript/typings/date-iso.d.ts": "./app/frontend/src/javascript/typings/date-iso.d.ts",
	"src/javascript/typings/import-png.d": "./app/frontend/src/javascript/typings/import-png.d.ts",
	"src/javascript/typings/import-png.d.ts": "./app/frontend/src/javascript/typings/import-png.d.ts",
	"src/javascript/typings/import-svg.d": "./app/frontend/src/javascript/typings/import-svg.d.ts",
	"src/javascript/typings/import-svg.d.ts": "./app/frontend/src/javascript/typings/import-svg.d.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/frontend/src/javascript/typings sync recursive .*";